export default "__VITE_ASSET__amnm7VwY__"